import React from 'react'
import { ComponentExt } from 'util/reactExt'
import { Icon, Carousel } from 'antd'
import styles from './index.scss'
import { inject, observer } from 'mobx-react'
import { Link } from 'util/utils'
import { RouteComponentProps, withRouter } from 'react-router-dom'
import UserStudyChart from 'containers/shared/UserStudyChart'

interface IUserStoreProps extends RouteComponentProps<any> {
  userStore?: IUserStore.UserStore
  history: any
}

@inject('userStore')
@observer
class JZUserPanel extends ComponentExt<IUserStoreProps> {
  state = {
    msgData: { data: [], total: 0 },
  }
  componentDidMount() {
    this.props.userStore.fetchUserLevel()
    this.fetchUserSystemNoticeList(1)
  }

  async fetchUserSystemNoticeList(pageindex) {
    const res = await this.api.user.getSystemNoticeList({
      pageindex,
      pagesize: 15,
    })
    this.setState({
      msgData: res,
    })
  }

  handleMsgClick() {
    this.props.history.push({
      pathname: `/usercenter/message`,
    })
  }

  render() {
    const { userInfo } = this.props.userStore
    const { msgData } = this.state
    return (
      <div className={styles.userPanel}>
        <div className={styles.userInfo}>
          <ul>
            <li style={{ marginRight: 14 }}>
              <img src={userInfo.img_url} alt="" />
            </li>
            <li style={{ marginRight: 60 }}>
              <p className={styles.boldText} style={{ textAlign: 'left' }}>
                {userInfo.staff_name}
              </p>
              <p className={styles.normalText} style={{ textAlign: 'left' }}>
                学习：{userInfo.learn_time}小时
              </p>
            </li>
            <li style={{ marginRight: 45 }}>
              <p className={styles.normalText}>专业等级</p>
              <Link to="http://xy.jingzhuan.cn/exam_vue/dist/prod/index.html#/exam/4">
                <p className={styles.boldText}>
                  {this.props.userStore.userLevel.professional_level}
                </p>
              </Link>
            </li>
            <li style={{ marginRight: 45 }}>
              <p className={styles.normalText}>业务等级</p>
              <Link to="http://xy.jingzhuan.cn/exam_vue/dist/prod/index.html#/exam/2">
                <p className={styles.boldText}>
                  {this.props.userStore.userLevel.business_level}
                </p>
              </Link>
            </li>
            <li>
              <p className={styles.normalText}>学习等级</p>
              <p className={styles.boldText}>待定</p>
            </li>
          </ul>
          <h4>
            <Icon
              type="notification"
              style={{ fontSize: 24, color: '#333', marginRight: 9 }}
            />
            系统通知
          </h4>
          <div className={styles.msgText} onClick={() => this.handleMsgClick()}>
            {msgData.data.length > 0 ? (
              <Carousel autoplay={true} dots={false}>
                {msgData.data.slice(0, 4).map(msg => (
                  <span key={msg.content}>{msg.content}</span>
                ))}
              </Carousel>
            ) : (
              '暂无通知'
            )}
            {!this.props.location.pathname.includes('/message') &&
              msgData.data.length > 0 && <i>更多></i>}
          </div>
        </div>
        <div className={styles.userStudyChart}>
          <UserStudyChart />
        </div>
      </div>
    )
  }
}
const UserPanel: any = withRouter(JZUserPanel)

export default UserPanel
